/**
 * @generated SignedSource<<de6469cf566ad41c4fb8d0e1096dc84e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CancelPhaseSignoffRequestInput = {
  psaMilestoneId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type cancelPhaseSignoffRequestMutation$variables = {
  input: CancelPhaseSignoffRequestInput;
};
export type cancelPhaseSignoffRequestMutation$data = {
  readonly cancelPhaseSignoffRequest: {
    readonly phase: {
      readonly id: string;
      readonly portalConfig: {
        readonly signoffRequestState: string | null;
        readonly signoffRequestDeadline: string | null;
        readonly signoffRequestApproverPortalUserId: string | null;
        readonly signoffChangesRequestedNote: string | null;
      } | null;
    } | null;
  } | null;
};
export type cancelPhaseSignoffRequestMutation = {
  variables: cancelPhaseSignoffRequestMutation$variables;
  response: cancelPhaseSignoffRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CancelPhaseSignoffRequestPayload",
    "kind": "LinkedField",
    "name": "cancelPhaseSignoffRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhasePortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestDeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestApproverPortalUserId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffChangesRequestedNote",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cancelPhaseSignoffRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cancelPhaseSignoffRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "06e13b83a8677411b8033ddb35bec8d4",
    "id": null,
    "metadata": {},
    "name": "cancelPhaseSignoffRequestMutation",
    "operationKind": "mutation",
    "text": "mutation cancelPhaseSignoffRequestMutation(\n  $input: CancelPhaseSignoffRequestInput!\n) {\n  cancelPhaseSignoffRequest(input: $input) {\n    phase {\n      id\n      portalConfig {\n        signoffRequestState\n        signoffRequestDeadline\n        signoffRequestApproverPortalUserId\n        signoffChangesRequestedNote\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0c800ca4c0999be4d4997d77256ed17";

export default node;
